(() => {
  if (window.rebuyUpdatesInitialized) return;
  window.rebuyUpdatesInitialized = true;

  const SHIPTECTION_HANDLE = 'shiptection-shipping-protection';

  const REBUY_EVENTS = [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.ready',
    'rebuy:smartcart.ready',
  ];

  function getDisplayItemCountFromCart(cart) {
    if (!cart?.items?.length) return 0;

    return cart.items.reduce((total, item) => {
      const handle = item.handle || item.product_handle;
      if (handle === SHIPTECTION_HANDLE) return total;
      return total + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  function getRebuyCart(event) {
    return event?.detail?.cart?.cart || window.Rebuy?.Cart?.cart;
  }

  function getDisplayItemCount(event) {
    const cart = getRebuyCart(event);
    if (cart?.items) return getDisplayItemCountFromCart(cart);
    return undefined;
  }

  function applySectionHtml(html) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || !html) return false;

    const sectionContent = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (!sectionContent) return false;

    cartIcon.innerHTML = sectionContent.innerHTML;
    return true;
  }

  function updateCountDisplay(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    const count = parseInt(itemCount, 10) || 0;
    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (count <= 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }

    let visibleCount = bubble.querySelector('span[aria-hidden="true"]');
    if (!visibleCount) {
      visibleCount = document.createElement('span');
      visibleCount.setAttribute('aria-hidden', 'true');
      bubble.prepend(visibleCount);
    }

    visibleCount.textContent = count < 100 ? String(count) : '';
  }

  function formatItemCountLabel(count) {
    return `${count} ${count === 1 ? 'item' : 'items'}`;
  }

  function updateRebuySubtotalLabel(displayCount) {
    document.querySelectorAll('.rebuy-cart__flyout-subtotal-label span').forEach((label) => {
      const html = label.innerHTML;
      const withParens = html.replace(
        /\((\d+)\s+items?\)/gi,
        `(${formatItemCountLabel(displayCount)})`
      );

      if (withParens !== html) {
        label.innerHTML = withParens;
        return;
      }

      const withCount = html.replace(
        /\b\d+\s+(?=items?\b)/gi,
        `${displayCount} `
      );

      if (withCount !== html) {
        label.innerHTML = withCount;
      }
    });
  }

  function updateCartIconBubble(sectionHtml, itemCount) {
    if (applySectionHtml(sectionHtml)) {
      const cart = getRebuyCart();
      if (cart?.items) updateRebuySubtotalLabel(getDisplayItemCountFromCart(cart));
      return Promise.resolve();
    }

    if (typeof itemCount !== 'undefined') {
      updateCountDisplay(itemCount);
      updateRebuySubtotalLabel(itemCount);
      return Promise.resolve();
    }

    const displayCount = getDisplayItemCount();
    if (typeof displayCount !== 'undefined') {
      updateCountDisplay(displayCount);
      updateRebuySubtotalLabel(displayCount);
      return Promise.resolve();
    }

    const root = window.Shopify?.routes?.root || '/';
    return fetch(`${root}?sections=cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        if (applySectionHtml(sections['cart-icon-bubble'])) return;
        return fetch(`${root}cart.js`).then((response) => response.json());
      })
      .then((cart) => {
        if (!cart?.items) return;
        const count = getDisplayItemCountFromCart(cart);
        updateCountDisplay(count);
        updateRebuySubtotalLabel(count);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  window.updateCartIconBubble = updateCartIconBubble;

  function onRebuyCartEvent(event) {
    const displayCount = getDisplayItemCount(event);
    updateCartIconBubble(null, displayCount);
  }

  REBUY_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, onRebuyCartEvent);
  });

  function observeRebuySubtotalLabel() {
    const cartRoot = document.querySelector('#rebuy-cart, .rebuy-cart');
    if (!cartRoot || cartRoot.dataset.subtotalObserver === 'true') return;

    cartRoot.dataset.subtotalObserver = 'true';

    const observer = new MutationObserver(() => {
      const cart = getRebuyCart();
      if (!cart?.items) return;
      updateRebuySubtotalLabel(getDisplayItemCountFromCart(cart));
    });

    observer.observe(cartRoot, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('rebuy:smartcart.ready', observeRebuySubtotalLabel);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const displayCount = event?.cartData?.items
        ? getDisplayItemCountFromCart(event.cartData)
        : event?.cartData?.item_count;

      updateCartIconBubble(
        event?.cartData?.sections?.['cart-icon-bubble'],
        displayCount
      );
    });
  }
})();
